import { observer } from "mobx-react-lite";
import { useRef } from "react";

import { routes } from "@libs/routing/routes.ts";
import { ConditionModalFormValues } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/condition-modal/Condition.types.ts";
import { ConditionHelper } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/context/ConditionHelper.ts";
import { OverviewCard } from "@modules/clinical/screens/shared-components/overview-card/OverviewCard.tsx";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";
import { useStores } from "@stores/hooks/useStores.ts";

import { ConditionCardIds } from "../ConditionScreen.tsx";

interface ConditionCardsProps {
  episodeOfCare: EpisodeOfCare;
}

export const ConditionCards: React.FC<ConditionCardsProps> = observer(
  ({ episodeOfCare }) => {
    const root = useStores();

    const conditionHelper = useRef(
      new ConditionHelper(root, episodeOfCare.patientId, {
        onSubmit: async (
          values: ConditionModalFormValues,
          helper: ConditionHelper
        ) => {
          await helper.submitUpdateConditionValues(
            values,
            values.referralIn
              ? episodeOfCare.nextCalendarEventProviderId
              : undefined
          );
        },
        onSubmitSucceeded: episodeOfCare => {
          if (!episodeOfCare.isPrivate && episodeOfCare.claim) {
            root.routing.push(
              {
                pathname: routes.claims.management.edit.path({
                  id: episodeOfCare.claim.id
                })
              },
              { openACC32Card: true }
            );
          }
        },
        episodeOfCare
      })
    );

    return (
      <OverviewCard
        cardId={ConditionCardIds.overview}
        referralIn={episodeOfCare.isReferral}
        conditionHelper={conditionHelper.current}
        initialCalendarEvent={episodeOfCare.initialCalendarEvent}
        initialConsultDate={episodeOfCare.initialCalendarEvent?.startDateTime}
        isClaim={true}
        onDialogOpened={() => conditionHelper.current.showConditionModal(false)}
        diagnoses={episodeOfCare.diagnoses.map(x => ({
          description: x.diagnosisCode?.originalText,
          side: x.diagnosisSide
        }))}
        isViewMode={episodeOfCare.inActiveClaim?.isViewMode}
      />
    );
  }
);
